import React, {useState} from 'react'
import {useDispatch} from "react-redux";
import {setVariable} from "redux/actions";
import {SET_SORT_TYPE} from "redux/types";
import {Menu, MenuItem} from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";
import ToolbarButton from "components/Toolbar/ToolbarButton";

const menuItems = [
    {title: 'Newest', value: 'created-desc'},
    {title: 'Oldest', value: 'created-asc'},
    {title: 'Unread', value: 'status-asc'},
]

const FilterButton = ({meta}) => {
    const dispatch = useDispatch();
    const [filterRecords, setFilterRecords] = useState(null);

    const handleMenu = (event) => filterRecords ? setFilterRecords(null) : setFilterRecords(event.currentTarget);
    const handleMenuItem = (value) => () => {
        dispatch(setVariable(SET_SORT_TYPE, value))
        handleMenu()
    };

    return (
        <div>
            <ToolbarButton
                title="SORT"
                onClick={handleMenu}
                disabled={meta?.total === 0}
                Icon={FilterListIcon}
            />
            <Menu id="simple-menu" anchorEl={filterRecords} keepMounted open={Boolean(filterRecords)}
                  onClose={handleMenu}>
                {menuItems.map((menuItem, index) =>
                    <MenuItem key={index} onClick={handleMenuItem(menuItem.value)}>{menuItem.title}</MenuItem>
                )}
            </Menu>
        </div>
    )
};

export default FilterButton;